import React from 'react';

import Img from '../atoms/Img';
import Box from '../atoms/Box';
import Text from '../atoms/Text';
import { useTranslate } from '../../translate/I18n';

const WhistleblowingPolicy = () => {
  const { t } = useTranslate(['legal']);

  return (
    <Box maxWidth="1280px" margin="auto">
      <Box>
        <Text as="h1" styleName="wH2" textAlign="center" p={5}>
          Whistleblowing Policy
        </Text>
      </Box>

      <Box textAlign="center" borderRadius={'100px'}>
        <Img
          src={'/assets/meta/whistleblowing-policy-meta.png'}
          fallback={'/assets/meta/whistleblowing-policy-meta.png'}
          width={960}
          height={400}
          alt="whistleBlowingPolicy"
        />
      </Box>

      <Box display="block" margin="auto" maxWidth="800px" p={4}>
        <Text as="p" mb={2}>
          Beelance is committed to being <strong>a responsible company</strong> and{' '}
          <strong>promotes ethical business conduct</strong> for all its stakeholders.
        </Text>

        <Text as="p" mb={2}>
          To support its commitment, Beelance is implementing its first <strong>Whistleblowing Policy</strong> in
          accordance with the requirements of the European Whistleblowing Directive. The tool will be implemented in
          Belgium, France, Luxembourg, Germany, Bulgaria, Austria and Switzerland.
        </Text>

        <Text as="p" mb={2}>
          A <strong>Whistleblower</strong> is a person who exposes information or an activity within our company that is
          deemed illegal, illicit, unsafe, a waste, fraud, or abuse of taxpayer funds. This Whistleblowing procedure
          allows witnesses or victims of serious incidents within the company to report facts or suspicions, while
          protecting them from any negative repercussions. Negative repercussions can be dismissal, demotion, reduction
          in wages, negative performance assessments, etc.
        </Text>

        <Text as="p" mb={2}>
          This Whistleblowing procedure <strong>will apply to the following persons</strong>: all employees, interns,
          volunteers, suppliers, subcontractors, clients, facilitators/intermediaries, shareholders, ex-employees,
          future employees during the recruitment process and third parties who are related to someone who works for the
          company and who could suffer retaliation in a work-related context.
        </Text>

        <Text as="p" mb={2}>
          <strong>The incidents and/or breaches</strong> which can be reported are the following:
        </Text>

        <Box display="block" pb={2}>
          <ul>
            <li>- Bribery and corruption;</li>
            <li>- Breaches of competition law;</li>
            <li>- Conflicts of interest;</li>
            <li>- Fraud;</li>
            <li>- Financial crimes;</li>
            <li>
              - Moral or sexual harassment (excluded for France and Switzerland who have their own internal procedure);
            </li>
            <li>- Discrimination;</li>
            <li>- Physical violence in the workplace</li>
          </ul>
        </Box>

        <Text as="p" mb={2}>
          You can make your reporting through the <strong>following link</strong>:{' '}
          <a href="https://positivethinking.integrityline.com" target="_blank" rel="noreferrer">
            https://positivethinking.integrityline.com
          </a>
          . Please don’t forget to choose your country and language before making the reporting.
        </Text>

        <Text as="p" mb={2}>
          Please be sure to read the Whistleblowing Policy in advance, which you can also find on the link mentioned
          above.
        </Text>

        <Text as="p" mb={2}>
          Should there be any concerns about this procedure, please address your questions to the Business Ethics
          Committee through the following e-mail address:{' '}
          <a href="mailto:BE_legal@positivethinking.tech">BE_legal@positivethinking.tech</a>.
        </Text>
      </Box>
    </Box>
  );
};

export default WhistleblowingPolicy;
